export default {
  heading: "設定電郵轉寄功能",
  userEmail: "教城電郵地址",
  fromEmail1: "將我的教城電郵地址 ",
  fromEmail2: " 轉寄至:",
  toEmail: "電郵地址",
  stopEmail: "我希望停用電郵轉寄功能",
  stopForwardingAlertTitle: "停用電郵轉寄功能",
  stopForwardingAlert: "停用電郵轉寄功能後，您將不能再重啟電郵轉寄功能。",
  retireMsg: "<b><u>教城電郵轉寄服務將於2027年1月31日起停止</u></b><p>為確保於電郵轉寄服務停止提供後，閣下仍可透過自行管理的電郵地址接收第三方服務的通知及通訊，我們建議　閣下及早採取以下措施：</p><ul class='pl-10'><li>檢查並更新相關服務帳戶所登記的聯絡電郵地址</li><li>改用可自行管理及長期有效的電郵地址作為相關服務的登記及聯絡電郵</li></ul><p>如　閣下需要延長服務以作相關安排，請於<b>2027年1月31日</b>前電郵至 <a href='mailto:support{'@'}edcity.hk'>support{'@'}edcity.hk</a> 提出申請，我們將按個別情況審核申請，並盡力提供適切協助。</p>",
  button: {
    back: "返回",
    stop: "停用",
  }

};
